var n=function(){return null},r=function(n){return n.ctrlKey||n.shiftKey};export{r as c,n};
//# sourceMappingURL=utils-c286d19e.js.map
